import { useBasisForm } from "basis";
import { Error } from "components/Error/Error";
import { EnhancedAccount } from "library/accounts/types";
import { FullPersonalDetails } from "pages/ManagePersonalDetails/types";
import { VerifyError } from "pages/ManagePersonalDetails/UpdateMobileNumber/VerifyError";
import { ExpiredOtp } from "./ExpiredOtp";
import { MobileNumberForm } from "./MobileNumberForm";
import { initialState, reducer } from "./reducer";
import { Success } from "./Success";
import { PhoneNumbersFormValues, Status } from "./types";
import { useScreenStatus } from "./useScreenStatus";
import { VerifyMobileNumber } from "./VerifyMobileNumber";

type Props = {
  account: EnhancedAccount;
  fullPersonalDetails: FullPersonalDetails;
};

export const UpdateMobileNumber = ({ account, fullPersonalDetails }: Props) => {
  const { state, dispatch } = useScreenStatus(reducer, initialState);
  const { methods } = useBasisForm<PhoneNumbersFormValues>();
  const { getValues } = methods;
  const mobileNumber = getValues("mobileNumber");
  const residentialCountry = fullPersonalDetails.residential.country;

  switch (state.status) {
    case Status.EXPIRED_OTP: {
      return (
        <ExpiredOtp
          dispatch={dispatch}
          token={state.token}
          createSessionUrl={state.createSessionUrl}
        />
      );
    }

    case Status.VERIFY: {
      return (
        <VerifyMobileNumber
          dispatch={dispatch}
          mobileNumber={mobileNumber}
          verifyUrl={state.updatePhoneVerify}
          resendUrl={state.updatePhoneResend}
          residentialCountry={residentialCountry}
        />
      );
    }

    case Status.VERIFY_ERROR: {
      return (
        <VerifyError
          dispatch={dispatch}
          title={state.title}
          message={state.message}
        />
      );
    }

    case Status.ERROR: {
      return <Error />;
    }

    case Status.SUCCESS: {
      return <Success phoneOtpResponse={state.phoneOtpResponse} />;
    }

    case Status.EXPIRED_OTP_SUCCESS: {
      return (
        <MobileNumberForm
          dispatch={dispatch}
          account={account}
          fullPersonalDetails={fullPersonalDetails}
          methods={methods}
          token2FaRenewed="yes"
        />
      );
    }

    default: {
      return (
        <MobileNumberForm
          dispatch={dispatch}
          methods={methods}
          account={account}
          fullPersonalDetails={fullPersonalDetails}
        />
      );
    }
  }
};
